import { TDMClient, type TDMTypes } from '@tf/api';

export const getTenantConfigQuery = async (tenant: string): Promise<TDMTypes.TenantConfig> => {
	const res = await TDMClient.getInstance().getConfig(tenant);
	return res.json();
};
